module.exports = __webpack_public_path__ + "static/media/proc.a24aaf21.png";